/**
 * Class for handling weather REST request
 * @copyright 2021-2022 Soter Technologies, LLC. All rights reserved.
 * @file weather.js
 * @author Matt Schreider, Kyle Watkins, Paul Scala
*/

class Weather {
    /**
     * Initialize class
     * @param {object} axios Axios instance
     * @param {object} session User session handler
     */
    constructor(axios, session) {
        this.axios = axios
        this.session = session
    }

    /**
     * Get weather for site
     * @param {string} siteId User's site id 
     * @returns {ResponseObject} API response object
     */
    async getWeather(siteId) {
        let query = this.session.getQuery({ siteId, page: null })

        let config = {
            method: 'get',
            url: `/api/weather?${query}`,
        }

        let res = await this.axios(config)
        
        return({
            status: res.status,
            statusText: res.statusText,
            isSuccess: (res.status >= 200 && res.status < 300),
            data: res.data
        })
    }
}

export default Weather